export const CreditorStatus = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
  TERMINATED: 'terminated'
};

export const CREDITOR_STATES = Object.values(CreditorStatus);

export default CreditorStatus;
